import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'
import { StatsType } from '../../types/types'



export const statsApi = createApi({
    reducerPath: 'statsApi',
    baseQuery: fetchBaseQuery({
        baseUrl: '/api/v2',
        prepareHeaders: (headers) => {
            const token = localStorage.getItem('token')
            if (token) {
                headers.set("Authorization", `Bearer ${token}`)
            }
            return headers
        }
    }),
    keepUnusedDataFor: 1,
    tagTypes: ['statsApi'],
    endpoints: (builder) => ({
        getStatsInfo: builder.query<StatsType, {start?: string,end?: string}>({
            query: ({start,end}) => ({
                url: `/self/stats?${start ? 'start='+start+'&' : ''}${end ? 'end='+end : ''}`,
                method: 'GET'
            })
        }),
        
    })
})

export const {
    useGetStatsInfoQuery
} = statsApi
